(function($, jimdoData, document, window) {
    "use strict";

    var adManager = {
        cssPath : (function() {
            var css = require('!!css-loader?root=~!../../../css/web/mobileAds.css');
            return css.toString();
        })(),
        adInsertBefore : '#cc-m-container',
        init : function(){
            var iframe = this.craeteIframe();
            this.insertAdCode(iframe);
        },
        craeteIframe : function (){
            var iframe = document.createElement("iframe");
            iframe.src = 'about:blank';
            iframe.id = 'adFrame';
            iframe.style.display = 'none';
            $(iframe).insertBefore(this.adInsertBefore);
            return iframe;
        },
        insertAdCode : function(iframe) {
            // Read Text and Link from hidden footer and use existing styles.
            var adText = $('#fallback-ad-textlink').text();
            var adLink = $('#fallback-ad-textlink').attr('href');
            var str = '<html>' +
                            '<head>' +
                                '<style type="text/css">' + this.cssPath + '</style>' +
                                '<base target="_blank">' +
                            '</head>' +
                            '<body>' +
                                '<div id="div-gpt-ad-1354803386637-0">' +
                                    '<aside>' +
                                        '<a href="' + adLink + '">' +
                                        '<div class="logo">&nbsp;</div>' +
                                        '<button class="btn red">' +
                                            '<span>' + adText + '</span>' +
                                        '</button>' +
                                        '</a>' +
                                    '</aside>' +
                                '</div>' +
                            '</body>' +
                        '</html>';

            var iframeContent = iframe.contentWindow || iframe.contentDocument;
            iframeContent.document.write(str);
            $(iframe).show();
        },
        getProtocol : ('https:' === document.location.protocol) ? 'https:' : 'http:'
    };

    // only show if a free user and not with internet explorer mobile
    // and not in debug (otherwise we get repeated access errors from Google's osd.js every 500ms which renders the preview undebugable)

    if(jimdoData && !jimdoData.isDebug && jimdoData.isFreePackage && !$.browser.msie && !jimdoData.isJimdoMobileApp){
        $(document).one("allModulesLoaded", function(){
            setTimeout(function(){
                // for frontpage preview and mobile app - dont show ad for free users
                if(window.location.hash !== '#noAd'){
                    adManager.init();
                }
            }, 400);
        });
    }
})(require('jquery'), require('jimdoData'), document, window);





/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobileAd.js
 ** module id = 3858
 ** module chunks = 100
 **/